import React from "react";

import Chip from "@mui/material/Chip";
import HtmlTooltip from "../../../Common/Tooltip/HtmlTooltip";

const DisplayCategories = ({ categories }) => {
    let display = "";

    if (categories?.length > 0) {
        display = categories.map((category) => (
            <HtmlTooltip
                key={category?.id}
                title={
                    <React.Fragment>
                        {category?.children?.length > 0 ? (
                            <ul>
                                {category.children.map((child) => (
                                    <li key={child?.id}>{child?.name}</li>
                                ))}
                            </ul>
                        ) : (
                            <em>{"No categories found"}</em>
                        )}
                    </React.Fragment>
                }
            >
                <Chip
                    key={category?.id}
                    color={"default"}
                    variant={"filled"}
                    className={"chip"}
                    label={`${category.name} - (${
                        category?.children?.length || 0
                    })`}
                />
            </HtmlTooltip>
        ));
    }

    return display;
};

export default DisplayCategories;
